import { EventEmitter } from '@apia/util';

const activitiesMap = Object.freeze({
  activitiesProjectManagement: '',
  activitiesSurveyAndScope: '',
  activitiesPrototype: '',
  activitiesPrototypeValidation: '',
  activitiesFunctionalImplementation: '',
  activitiesTechnicalImplementation: '',
  activitiesTesting: '',
  activitiesFinalAdjustments: '',
  activitiesDocumentation: '',
  activitiesTraining: '',
  activitiesInstallation: '',
  activitiesDeployment: '',
});

const rolesMap = Object.freeze({
  rolesServicesDirector: '',
  rolesSalesExecutive: '',
  rolesProjectManager: '',
  rolesFunctionalConsultant: '',
  rolesExternalFunctionalConsultant: '',
  rolesTechnicalSolutionArchitect: '',
  rolesTechnicalComponentsProgrammer: '',
  rolesBlackBoxTester: '',
});

export type TActivities = string;
export type TRoles = string;

export const activities = Object.freeze(
  Object.keys(activitiesMap),
) as TActivities[];
export const roles = Object.freeze(Object.keys(rolesMap)) as TRoles[];

export type TActivitiesData = Record<TActivities, Record<TRoles, number>>;
export type TDistribution = Record<TActivities, number>;

export class RolesManager extends EventEmitter<{ rolesListUpdate: string[] }> {}
